import gsap from 'gsap';
export default function InitPreloader() {
  return new Promise((resolve) => {
    const MIN_DURATION = 800;
    const EXIT_DURATION = 800;
    const FAKE_MAX = 100;
    const ONLY_ONCE = false;
    const SHOW_PERCENT = true;
    const IS_DISABLE = false;

    const wrapper = document.querySelector('.preloader--wrapper');
    const counterEl = document.querySelector('.preloader--counter');
    const bgEl = document.querySelector('.preloader--bg');
    const sloganEl = document.querySelector('.preloader--slogan');
    const siteMainEl = document.querySelector('.site-main');

    if (!wrapper || !counterEl || !bgEl || !sloganEl) return;

    document.body.classList.add('is-loading');

    const setVH = () =>
      document.documentElement.style.setProperty(
        '--vh',
        window.innerHeight * 0.01 + 'px'
      );
    setVH();
    window.addEventListener('resize', setVH);

    if (ONLY_ONCE && sessionStorage.getItem('preloaderShown') === '1') {
      instantHide();
      return;
    }

    if (IS_DISABLE) {
      instantHide();
      return;
    }

    counterEl.textContent = SHOW_PERCENT ? '000%' : '000';

    let startTime = performance.now();
    let rafId = 0;
    let isLoaded = false;
    let fakeVal = 0;

    function easeOutQuad(t) {
      return t * (2 - t);
    }

    function tick(now) {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / 1200, 1);
      fakeVal = Math.min(Math.floor(easeOutQuad(t) * FAKE_MAX), FAKE_MAX - 1);
      setCounter(fakeVal);

      if (readyToFinish()) {
        cancelAnimationFrame(rafId);
        finalize();
      } else {
        rafId = requestAnimationFrame(tick);
      }
    }

    function setCounter(v) {
      const num = Math.floor(
        Math.max(0, Math.min(100, Number.isFinite(v) ? v : Number(v)))
      );
      const padded = String(num).padStart(3, '0');
      counterEl.textContent = SHOW_PERCENT ? `${padded}%` : padded;
    }

    function readyToFinish() {
      const elapsed = performance.now() - startTime;
      return isLoaded && elapsed >= MIN_DURATION && fakeVal >= FAKE_MAX - 1;
    }

    function finalize() {
      const obj = { n: fakeVal };
      gsap.to(obj, {
        n: 100,
        duration: 0.25,
        ease: 'power1.out',
        onUpdate: () => setCounter(obj.n),
        onComplete: sequenceExit,
      });
    }

    function sequenceExit() {
      const tl = gsap.timeline({
        default: { ease: 'power4.inOut' },
      });

      tl.to(bgEl, {
        yPercent: -100,
        duration: 0.6,
      })
        .to(
          counterEl,
          {
            yPercent: 60,
            opacity: 0,
            ease: 'power1.in',
            duration: 0.7,
          },
          '+=0.1'
        )
        .to(sloganEl, { opacity: 0, yPercent: 10, duration: 0.5 }, '>')
        .to(wrapper, { opacity: 0, duration: 0.5, ease: 'power2.out' }, '>')
        .add(() => {
          cleanup();
          if (ONLY_ONCE) sessionStorage.setItem('preloaderShown', '1');
        });
    }

    function cleanup() {
      document.body.classList.remove('is-loading');
      document.body.classList.add('is-loaded');
      wrapper.remove();
      cancelAnimationFrame(rafId);
      resolve();
    }

    function instantHide() {
      document.body.classList.remove('is-loading');
      document.body.classList.add('is-loaded');
      wrapper.style.display = 'none';
      resolve();
      if (ONLY_ONCE) sessionStorage.setItem('preloaderShown', '1');
    }

    window.addEventListener(
      'load',
      () => {
        isLoaded = true;
      },
      { once: true }
    );

    rafId = requestAnimationFrame(tick);
  });
}
